function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Modifier from 'ember-modifier';
import { openModal, dismissModal } from '@market/ember';
/*
 * Automatically opens the modal template it's attached to on first render.
 *
 * Usage:
 *
 * {!-- parent.hbs --}
 * <CoolModal {{open-modal}} />
 *
 * {!-- cool-modal.hbs --}
 * <template ...attributes>
 *   <market-modal-partial>
 *     Cool modal content goes here
 *   </market-modal-partial>
 * </template>
 */

export default class OpenModal extends Modifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "modal", void 0);
  }
  async didInstall() {
    const selector = this.args.positional[0];
    this.modal = await openModal(this.element, selector);
  }
  willDestroy() {
    // Don't dismiss the modal if it is no longer present in the DOM.
    if (this.modal !== undefined && document.getElementById(this.modal.id)) {
      dismissModal(this.modal);
    }
    this.modal = undefined;
  }
}